import {ReactComponent as CloseIcon} from "../../../core/ui/icon/Close.svg";

import "./_modal-header.scss";

import classNames from "classnames";

import Typography from "../../typography/Typography";
import {ButtonProps} from "../../button/Button.types";
import IconButton from "../../button/icon/IconButton";

interface ModalHeaderProps {
  closeButtonProps?: Omit<ButtonProps, "children">;
  title?: string;
  customClassName?: string;
}

function ModalHeader({title, customClassName, closeButtonProps}: ModalHeaderProps) {
  return (
    <header
      className={classNames(
        "modal-header",
        "has-space-between",
        "is-vertically-centered",
        customClassName
      )}>
      {title && (
        <Typography as={"h2"} variant={"title"} customClassName={"modal-header__title"}>
          {title}
        </Typography>
      )}

      {closeButtonProps && (
        <IconButton
          {...closeButtonProps}
          customClassName={classNames(
            "modal-header__close-button",
            closeButtonProps.customClassName
          )}>
          <CloseIcon />
        </IconButton>
      )}
    </header>
  );
}

export default ModalHeader;
